{
  "title": "Chat",
  "search": {
    "next": "Nächster (Enter)",
    "prev": "Vorheriger (Shift+Enter)",
    "close": "Schließen (ESC)"
  },
  "lightbox": {
    "view_full": "Bild in Originalgröße anzeigen",
    "close": "Schließen (Esc)",
    "close_aria": "Schließen",
    "download": "Original herunterladen",
    "download_aria": "Bild herunterladen"
  },
  "effort": {
    "off_label": "Aus",
    "off_title": "Kein Reasoning-Effort",
    "default_label": "Standard ({{level}})",
    "default_title": "Agent-Standard verwenden (in den Einstellungen festgelegt)",
    "low_title": "Schnell & günstig — einfache Aufgaben",
    "medium_title": "Ausgewogen zwischen Tempo und Tiefe",
    "high_title": "Tiefes Reasoning (Standard auf Opus)",
    "xhigh_title": "Long-Horizon — empfohlen für Agentic Coding",
    "max_title": "Maximale Tiefe, keine Token-Grenze"
  },
  "model_hint": "Modell für diesen Agenten wechseln (gilt für alle Sessions)",
  "model": "Modell",
  "effort_label": "Tiefe",
  "tabs": {
    "direct": "Direkt",
    "projects": "Projekte"
  },
  "session": {
    "list_title": "Sessions",
    "new": "Neue Session",
    "no_sessions": "Noch keine Sessions",
    "no_buddy": "Keine Buddy-Sessions",
    "no_direct": "Keine direkten Chats",
    "no_project": "Keine Projekt-Chats",
    "select_or_new": "Wähle rechts eine Session oder starte eine neue.",
    "without_title": "Ohne Titel",
    "id_short": "Session-ID",
    "system_prompt_label": "System-Prompt:",
    "orphaned": "verwaist",
    "orphaned_banner": "Diese Session ist verwaist — der zugehörige Agent wurde gelöscht.",
    "new_chat": "Neuer Chat",
    "context_large": "Kontext: ~{{tokens}} Token. Neuer Chat spart ~{{savings}} Token.",
    "delete_session": "Session löschen",
    "delete_confirm": "Session wirklich löschen?",
    "unknown_project": "(unbekanntes Projekt)",
    "title_placeholder": "z.B. Recherche zur Idee XY",
    "title_label": "Titel (optional)"
  },
  "new_dialog": {
    "title": "Neue Session",
    "mode": {
      "direct": "Direkter Chat",
      "direct_hint": "Mit einem Master- oder Specialist-Agent",
      "project": "Im Projekt",
      "project_hint": "Mit einem Project-Agent in dessen Workspace"
    },
    "agent_label": "Agent",
    "no_agents": "Kein aktiver Agent verfügbar.",
    "project_label": "Projekt",
    "no_projects": "Kein aktives Projekt vorhanden.",
    "start": "Starten"
  },
  "input": {
    "placeholder": "Nachricht schreiben…",
    "placeholder_disabled": "Wähle erst eine Session…",
    "hint": "Enter zum Senden · Shift+Enter für neue Zeile",
    "stop_title": "Stop — Antwort abbrechen"
  },
  "upload": {
    "button_title": "Datei anhängen",
    "file_too_large": "{{name}} ist zu groß. Maximal {{maxMiB}} MiB pro Datei.",
    "total_too_large": "Die Anhänge sind zusammen zu groß. Maximal {{maxMiB}} MiB pro Nachricht.",
    "too_many": "Es sind maximal {{maxFiles}} Dateien pro Nachricht erlaubt."
  },
  "messages": {
    "empty": "Schreibe eine Nachricht um zu starten…",
    "iteration": "Iteration {{n}}…"
  },
  "tokens": {
    "last_turn": "letzter Turn",
    "tooltip": "Input ↑ · Output ↓ · Cache-Read ⚡ · Cache-Write 💾",
    "limit_tooltip": "Compact-Schwelle bei {{limit}} Tokens",
    "compact_imminent": "Compact bald",
    "compact_imminent_tooltip": "Auto-Compaction wird beim nächsten Turn ausgelöst — vorher manuell compactieren möglich.",
    "turns_tooltip": "Nachrichten: {{count}} / {{max}} — Compaction feuert auch beim Erreichen dieser Zahl, nicht nur an der Token-Schwelle."
  },
  "compact": {
    "button": "Compact",
    "tooltip": "Konversation jetzt zusammenfassen",
    "skipped": "Übersprungen: {{reason}}",
    "result": "{{summarized}} Messages komprimiert, {{kept}} behalten",
    "result_with_tokens": "{{summarized}} Messages komprimiert, {{kept}} behalten · {{tokens}} Tokens",
    "reasons": {
      "too_short": "zu kurz",
      "nothing_to_compact": "nichts zu kompaktieren",
      "empty_to_summarize": "leerer to_summarize",
      "cancelled_by_hook": "abgebrochen von {{hook}}"
    }
  },
  "compaction_block": {
    "title": "Konversation zusammengefasst",
    "stats_with_tokens": "{{tokens}} Tokens komprimiert · {{read}} gelesene · {{modified}} geänderte Dateien",
    "stats": "{{read}} gelesene · {{modified}} geänderte Dateien",
    "files_read": "Gelesene Dateien",
    "files_modified": "Geänderte Dateien",
    "summary": "Zusammenfassung"
  },
  "bubble": {
    "copy": "Kopieren",
    "raw": "Raw JSON",
    "persisted": "Gesendet",
    "pending": "Wird gesendet…",
    "edit": "Bearbeiten",
    "cancel": "Abbrechen",
    "resend": "Neu senden",
    "resend_hint": "Strg+Enter zum Senden, Esc zum Abbrechen. Verlauf ab dieser Nachricht wird verworfen.",
    "retry": "Neu generieren",
    "retry_hint": "Antwort verwerfen und Frage neu beantworten lassen."
  },
  "bubble_footer": {
    "tokens": "{{in}} ↑ · {{out}} ↓",
    "cache": "Cache {{read}}r / {{create}}c",
    "iterations": "{{n}} Iterationen",
    "stop_reason": "Stop: {{reason}}",
    "cost_tooltip": "Geschätzte Kosten basierend auf öffentlichen Provider-Preisen pro 1M Tokens. Cache-Read und Cache-Write werden mitgerechnet."
  },
  "tool_result": {
    "collapsed": "Output ({{chars}} Z., {{lines}} Zeilen) — anzeigen"
  },
  "voice": {
    "speak": "Vorlesen",
    "stop": "Stop",
    "click_to_speak": "Klicken zum Sprechen",
    "click_to_stop": "Klicken zum Beenden"
  },
  "model_switch": "Modell wechseln",
  "project_picker_title": "Aktives Projekt — bestimmt das Arbeitsverzeichnis",
  "skill_catalog": {
    "title": "Skill-Katalog",
    "insert_hint": "Klick fügt Skill als Anweisung in die Eingabe ein",
    "loading": "Lade…",
    "empty": "Keine Skills verfügbar"
  },
  "agent_monitor": {
    "ready": "Bereit",
    "done": "Fertig!"
  },
  "panel": {
    "expand": "Aufklappen",
    "collapse": "Einklappen"
  },
  "max_iter": {
    "continue_send": "Weitermachen, bitte fortsetzen.",
    "continue_label": "Weitermachen"
  },
  "tool_confirm": {
    "message": "Agent möchte folgendes Tool ausführen:",
    "protected": "Geschützter Zugriff — Bestätigung nötig:",
    "approve": "Erlauben",
    "deny": "Verweigern"
  },
  "prompts": {
    "button_title": "Prompt-Archiv",
    "search": "Prompts durchsuchen …",
    "loading": "Lade …",
    "empty": "Noch keine Prompts gespeichert.",
    "use": "In den Chat übernehmen",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "used_n": "{{n}}× genutzt",
    "confirm_delete": "Prompt „{{title}}\" wirklich löschen?",
    "new_title": "Neuer Prompt",
    "edit_title": "Prompt bearbeiten",
    "field_title": "Titel (z. B. HydraHive Maskottchen)",
    "field_prompt": "Prompt-Text (das Motiv)",
    "field_style_anchor": "Stil-Anker — bleibt bei Serien gleich (z. B. flat vector, warme Erdtöne)",
    "field_model": "Modell (optional, z. B. openai/gpt-5-image-mini)",
    "field_tags": "Tags, kommagetrennt",
    "field_notes": "Notizen (optional)",
    "field_public": "Öffentlich — für andere sichtbar",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "cat": {
      "all": "Alle",
      "image": "Bild",
      "music": "Musik",
      "system": "System",
      "video": "Video",
      "speech": "Sprache",
      "other": "Sonstiges"
    }
  },
  "delegation": {
    "result_title_one": "Ergebnis vom Spezialisten",
    "result_title_other": "Ergebnisse von {{count}} Spezialisten",
    "running": "arbeitet seit {{minutes}} min · Runde {{rounds}}",
    "cancel": "Auftrag abbrechen",
    "waiting": "Ergebnis liegt bereit — wird nach deiner nächsten Nachricht ausgewertet",
    "deliver_now": "Jetzt auswerten",
    "status": {
      "running": "läuft",
      "done": "fertig",
      "error": "Fehler",
      "paused": "pausiert",
      "timeout": "keine Antwort",
      "cancelled": "abgebrochen",
      "lost": "verloren"
    }
  }
}
